import { useTranslation } from "react-i18next";
import img from "../../assets/img/illu/balade-arbre.webp";

export default function Montessori() {
  const { t } = useTranslation();

  return (
    <section className="Montessori fade">
      <div className="montessori-text">
        <h2>{t("montessori.title")}</h2>
        <div className="desc">
          <article>
            <p>{t("montessori.p1")}</p>
            <p>{t("montessori.p2")}</p>
          </article>
          <article>
            <p>{t("montessori.p3")}</p>
            <p>{t("montessori.p4")}</p>
            <p>{t("montessori.p5")}</p>
          </article>
        </div>
      </div>
      <div className="montessori-img">
        <img src={img} alt="Montessori" />
      </div>
    </section>
  );
}
